import discardMessageOption from './actions/discardMessageOption';
import saveMessageOption from './actions/saveMessageOption';
import MessageOptionsFull from './components/MessageOptionsFull';
import isMessageOptionDirty from './utils/isMessageOptionDirty';
import * as React from 'react';
var MessageOption = {
    key: 'message',
    titleStringKey: 'optionTitle_message',
    searchTermsStringKey: 'optionTitle_message',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessageOptionsFull, null); },
        isDirty: isMessageOptionDirty,
        onSave: saveMessageOption,
        onDiscard: discardMessageOption,
    },
};
export default MessageOption;
//# sourceMappingURL=MessageOption.js.map